import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { MenuItem as MuiMenuItem } from '@mui/material';

const StyledMenuItem = styled(MuiMenuItem)`
  color: ${({ theme }) => theme.palette.grey[100]};
  &:hover {
    background-color: ${({ theme }) => theme.palette.primary[5]};
    color: ${({ theme }) => theme.palette.text.primary};
  }
`;

export const MenuItem = ({ children, ...props }) => (<StyledMenuItem {...props}>{children}</StyledMenuItem>);

MenuItem.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
